import type {SketchPointObject} from '../../../../../mesh/sketch';
import {SketchRelationKind} from '../../relation-compatibility/SketchRelationKinds';
import {MultiTargetRelation} from '../MultiTargetRelation';

let count = 0;
const MIN_DISTANCE = 1e-8;

/** 点距公式度量方向。 */
export type PointDistanceMeasureDirection = 'aligned' | 'x' | 'y';

/**
 * 判断对象是否为点距关系。
 * @param value 待判断对象。
 * @returns 是否为点距关系。
 */
export function isPointDistanceConstraint(value: object): value is PointDistanceConstraint {
    return Reflect.get(value, 'isPointDistanceConstraint') === true;
}

/**
 * 点到点距离关系定义。
 *
 * 锁定值和度量方向属于关系领域数据，几何计算由统一参数公式完成。
 */
export class PointDistanceConstraint extends MultiTargetRelation<SketchPointObject> {
    /** 运行时类型标记。 */
    public readonly isPointDistanceConstraint = true;
    /** 关系类型。 */
    public relationType = SketchRelationKind.Distance;
    /** 锁定距离。 */
    private lockedDistance: number | null = null;
    /** 度量方向。 */
    private readonly measureDirection: PointDistanceMeasureDirection;

    /**
     * @param distance 锁定距离；未提供时保持未锁定。
     * @param measureDirection 度量方向。
     */
    public constructor(
        distance?: number,
        measureDirection: PointDistanceMeasureDirection = 'aligned',
    ) {
        super();
        this.measureDirection = measureDirection;
        this.name = `${this.baseDisplayName}${count}`;
        count += 1;
        if (typeof distance === 'number') {
            this.setLockedDistance(distance);
        }
    }

    /** 基础显示名。 */
    public get baseDisplayName(): string {
        return '距离';
    }

    /** @returns 当前度量方向。 */
    public getMeasureDirection(): PointDistanceMeasureDirection {
        return this.measureDirection;
    }

    /** @returns 锁定距离；未锁定返回 null。 */
    public getLockedDistance(): number | null {
        return this.lockedDistance;
    }

    /**
     * 设置锁定距离。
     * @param distance 新距离。
     */
    public setLockedDistance(distance: number): void {
        if (!Number.isFinite(distance) || distance <= MIN_DISTANCE) {
            return;
        }
        this.lockedDistance = distance;
    }
}
